import { Article } from "@tm/models"
import { ArticleInternal } from "../models"

export function mapToInternalArticle(article: Article): ArticleInternal {
    return {
        id: article.id,
        internalId: article.internalId,
        description: article.description,
        quantity: article.quantity,
        traderArticleNo: article.traderArticleNo,
        supplierArticleNo: article.supplierArticleNo,
        supplier: article.supplier,
        productGroup: article.productGroup,
    }
}
